<template>
  <section
    :class="{
      [$style.section]: true,
      [$style.alternateBackground]: useAlternateBgColor,
      [backgroundClass]: !useAlternateBgColor,
    }"
  >
    <slot />
  </section>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    useAlternateBgColor: {
      type: Boolean,
      default: false,
    },
    backgroundClass: {
      type: String,
      default: 'bg-white',
    },
  },
});
</script>

<style lang="scss" module>
@import '../styles/variables-entry';
@import '../styles/variables';

.section {
  padding-top: 3rem;
  padding-bottom: 4rem;
  @include media-breakpoint-up($page-breakpoint-switch) {
    padding-top: 6rem;
    padding-bottom: 8rem;
  }
}

.alternateBackground {
  background-color: $page-alternate-bg-color;
}
</style>
